<mat-drawer-container hasBackdrop>
  @if (isAdmin()) {
    <mat-drawer
      autoFocus="false"
      #drawer
      mode="over"
      position="end"
      (closed)="close()"
    >
      <app-right-sidebar-container
        [title]="(isEditing ? 'Update' : 'Create') + ' Lender'"
        [footerSubmitCustomLabel]="isEditing ? 'Update' : 'Create'"
        (cancel)="close()"
        (submit)="onSubmit()"
        [disableSubmit]="form.invalid || isLoading"
      >
        <form [formGroup]="form" class="provider-content">
          <div class="custom-form-field">
            <label for="email"
              >Email address<span class="required">*</span></label
            >
            <mat-form-field appearance="outline" class="custom-field">
              <input formControlName="email" matInput name="email" />
              @if (form.controls['email'].errors?.['required']) {
                <mat-error>
                  Enter email address
                </mat-error>
              }
              @if (form.controls['email'].errors?.['email']) {
                <mat-error>
                  Enter valid email address
                </mat-error>
              }
              @if (form.controls['email'].errors?.['entityExists']) {
                <mat-error>
                  User already exists with this email
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="custom-form-field">
            <label for="firstName"
              >First Name<span class="required">*</span></label
            >
            <mat-form-field appearance="outline" class="custom-field">
              <input formControlName="firstName" matInput name="firstName" />
              @if (form.controls['firstName'].errors?.['required']) {
                <mat-error>
                  Enter First Name
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="custom-form-field">
            <label for="lastName">Last Name<span class="required">*</span></label>
            <mat-form-field appearance="outline" class="custom-field">
              <input formControlName="lastName" matInput name="lastName" />
              @if (form.controls['lastName'].errors?.['required']) {
                <mat-error>
                  Enter Last Name
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="custom-form-field">
            <label for="phoneNumber"
              >Phone Number<span class="required">*</span></label
            >
            <mat-form-field appearance="outline" class="custom-field">
              <input 
                formControlName="phoneNumber" 
                matInput 
                name="phoneNumber"
                type="tel"
                maxlength="10"
                minlength="10"
                [appPhoneInput]="true"
              />
              @if (form.controls['phoneNumber'].errors?.['required']) {
                <mat-error>
                  Enter Phone Number
                </mat-error>
              }
              @if (form.controls['phoneNumber'].errors?.['invalidPhone'] || form.controls['phoneNumber'].errors?.['minlength']) {
                <mat-error>Phone number must be exactly 10 digits</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="custom-form-field">
            <label for="role">Access Level<span class="required">*</span></label>
            <mat-form-field appearance="outline" class="custom-field">
              <mat-select formControlName="role" name="role">
                @for (option of roleOptions; track option.id) {
                  <mat-option [value]="option.id">{{ option.name }}</mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>expand_more</mat-icon>
              @if (form.controls['role'].errors?.['required']) {
                <mat-error>Select an access level</mat-error>
              }
            </mat-form-field>
          </div>
        </form>
      </app-right-sidebar-container>
    </mat-drawer>
  }
  <mat-drawer-content>
    <div class="pcs-container">
      <div class="pcs-header">
        <h3 class="pcs-title">
          {{ organization?.name || "-" }} (<strong>{{
            organization?.acronym || "-"
          }}</strong
          >)
        </h3>
      </div>
      <br />
      <div class="card-body">
        <app-row-details-data
          [data]="descriptionRowData"
        ></app-row-details-data>
        <br />

        <div>
          <mat-tab-group
            class="provider-tabs"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
          >
            @if (!isProvider() && !isProviderReadOnly()) {
              <mat-tab label="Users">
                <ng-template matTabContent>
                  <div class="pcs-container">
                    <div class="pcs-header">
                      <h3 class="pcs-title">Users</h3>
                    @if (isAdmin()) {
                      <div class="card-actions">
                        <button
                          (click)="openLenderSidebar()"
                          mat-flat-button
                          color="primary"
                          type="button"
                        >
                          <mat-icon>add</mat-icon> Create
                        </button>
                      </div>
                    }
                    </div>
                    <app-search-sort
                      [searchControl]="searchControl"
                      [sortForm]="sortForm"
                      [sortOptions]="sortOptions"
                      (apply)="setSortField()"
                      (close)="resetSortField()"
                    ></app-search-sort>
                    <div class="pro-card col">
                      <app-ag-grid-wrapper
                        [data]="rowData"
                        [columns]="columnDefs"
                        (ready)="onGridReady($event)"
                      />
                      <mat-paginator
                        #paginator
                        [selectConfig]="{
                          panelClass: 'mat-paginator-select-options'
                        }"
                        [length]="totalCount"
                        [pageIndex]="currentPage"
                        [pageSize]="pageSize"
                        [pageSizeOptions]="pageSettings.pageSizeOptions"
                        (page)="handlePageEvent($event)"
                        aria-label="Select page"
                      >
                      </mat-paginator>
                    </div>
                  </div>
                </ng-template>
              </mat-tab>
            }
            <mat-tab label="Relationships">
              <ng-template matTabContent>
                <div class="relationships-wrapper">
                  <app-org-structure 
                    [organizationId]="organizationId" 
                    [organization]="organization"
                    [organizationService]="lenderOrganizationService"
                    [isAdmin]="isAdmin()" 
                    [isSystemUser]="isSystemUser()"  
                    (relationshipsChanged)="onStructureChanged()">
                  </app-org-structure>

                  <app-org-associations 
                    #orgAssociations
                    [organizationId]="organizationId" 
                    [organizationService]="lenderOrganizationService"
                    [isAdmin]="isAdmin()" 
                    [isSystemUser]="isSystemUser()">
                  </app-org-associations>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab label="Products">
              <ng-template matTabContent>
                @for (data of productData; track data) {
                  <div class="pro-card product-card"
                  >
                    <div class="product-row">
                      <p class="product-card-title">
                        {{ data.product.name }}
                      </p>
                    </div>
                    <div 
                    class="product-row"
                    >
                      <div class="product-state-container">
                        <p class="product-states-title">Applicable States:</p>
                        <div class="product-state-legend">
                          <div class="legend-item">
                            <span class="legend-indicator active"></span>
                            <span>Applicable</span>
                          </div>
                          <div class="legend-item">
                            <span class="legend-indicator inactive"></span>
                            <span>Not Applicable</span>
                          </div>
                        </div>                        
                        <div class="product-state-detail-container">
                          @for (state of statesList; track state) {
                            <div
                              class="product-state-detail"
                              [ngClass]="{'missing': isStateMissing(state.id, data.states)}"
                            >
                              {{ state.name }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
